import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Optional, Output } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { PopulationService } from "../../../../../swaggerServices/api/api";
import { ConfigStateService } from "../../../../app/config/config-state.service";
import { TenantConfigService } from "../../../services/tenant-config.service";

export interface BulkProcessNoQnrDialogData {
  populationId: number;
}

@Component({
    selector: "app-bulk-process-no-qnr",
    templateUrl: "./bulk-process-no-qnr.component.html",
    styleUrls: ["./bulk-process-no-qnr.component.scss"],
    standalone: false
})
export class BulkProcessNoQnrComponent implements OnInit, OnDestroy {
  @Input() populationId: number;
  @Output() dismiss: EventEmitter<any> = new EventEmitter<any>();
  @Output() success: EventEmitter<any> = new EventEmitter<any>();
  @Output() error: EventEmitter<any> = new EventEmitter<any>();
  bulkProcessing = false;
  subscriptions: Subscription[] = [];
  uiConfig: TenantConfigService;
  taxReturnAlias: string;

  constructor(
    private config: ConfigStateService,
    private populationService: PopulationService,
    @Optional() private dialogRef?: MatDialogRef<BulkProcessNoQnrComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) private data?: BulkProcessNoQnrDialogData,
  ) {
  }

  ngOnInit() {
    if (!this.populationId && this.data?.populationId) {
      this.populationId = this.data.populationId;
    }

    this.subscriptions.push(
      this.config.loadConfig().subscribe(config => {
        this.uiConfig = new TenantConfigService(config);
        this.taxReturnAlias = this.uiConfig.config.taxReturnAlias
      })
    );
  }

  process() {
    this.bulkProcessing = true;
    this.populationService.startProcess(this.populationId).subscribe(() => {
      this.success.emit('BULK_PROCESS_SUCCESS');
      this.bulkProcessing = false;
      this.dialogRef?.close(true);
    }, () => {
      this.error.emit();
      this.bulkProcessing = false;
      this.dialogRef?.close(false);
    });
  }

  closeModal() {
    if (this.dialogRef) {
      this.dialogRef.close(false);
      return;
    }
    this.dismiss.emit();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

}
